/*
 * Urban Dekoy Music Catalog App - DEPLOYMENT READY VERSION
 * Copy this entire file to replace your App.js in GitHub
 */

import React, { useState, useMemo, useEffect } from 'react';

const VERSION = "v3.0.1";

// Complete catalog with both regular and artwork embeds - ALL SYNTAX FIXED
const musicCatalog = [
  {
    id: 1,
    name: "North Mills",
    year: 2025,
    tags: {
      intensity: ["Medium"],
      standalone: ["Tech"],
      context: ["Dancefloor"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/album=1241473737/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/album/north-mills">North Mills by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/album=1241473737/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/album/north-mills">North Mills by Urban Dekoy</a></iframe>'
  },
  {
    id: 2,
    name: "Low pass therapy",
    year: 2024,
    tags: {
      standalone: ["Quirky", "303", "Tech"],
      context: ["Listening"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=3079250373/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/low-pass-therapy">Low pass therapy by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=3079250373/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/low-pass-therapy">Low pass therapy by Urban Dekoy</a></iframe>'
  },
  {
    id: 3,
    name: "Vibechording",
    year: 2025,
    tags: {
      intensity: ["Soft"],
      context: ["Dancefloor"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=862584840/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/vibechording">Vibechording by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=862584840/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/vibechording">Vibechording by Urban Dekoy</a></iframe>'
  },
  {
    id: 4,
    name: "Berlinlogue",
    year: 2024,
    tags: {
      intensity: ["Medium"],
      context: ["Dancefloor"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=642989394/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/berlinlogue">Berlinlogue by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=642989394/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/berlinlogue">Berlinlogue by Urban Dekoy</a></iframe>'
  },
  {
    id: 5,
    name: "Kimono groove",
    year: 2024,
    tags: {
      intensity: ["Harder"],
      context: ["Dancefloor"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=1396215131/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/kimono-groove">Kimono groove by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=1396215131/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/kimono-groove">Kimono groove by Urban Dekoy</a></iframe>'
  },
  {
    id: 6,
    name: "Metal blizzard",
    year: 2024,
    tags: {
      standalone: ["Quirky"],
      context: ["Listening"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=2803246998/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/metal-blizzard">Metal Blizzard by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=2803246998/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/metal-blizzard">Metal Blizzard by Urban Dekoy</a></iframe>'
  },
  {
    id: 7,
    name: "Ultimo",
    year: 2024,
    tags: {
      context: ["Dancefloor"],
      intensity: ["Medium"],
      standalone: ["Tech"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=2435162494/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/ultimo-2">Ultimo by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=2435162494/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/ultimo-2">Ultimo by Urban Dekoy</a></iframe>'
  },
  {
    id: 8,
    name: "Stompa",
    year: 2024,
    tags: {
      context: ["Listening"],
      standalone: ["Quirky"],
      intensity: ["Harder"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=549997188/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/stompa">Stompa by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=549997188/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/stompa">Stompa by Urban Dekoy</a></iframe>'
  },
  {
    id: 9,
    name: "Breakthrough",
    year: 2024,
    tags: {
      context: ["Listening"],
      intensity: ["Medium"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=1480612126/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/break-through">Break through by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=1480612126/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/break-through">Break through by Urban Dekoy</a></iframe>'
  },
  {
    id: 10,
    name: "Saturation EP",
    year: 2024,
    tags: {
      context: ["Dancefloor"],
      intensity: ["Harder"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/album=3511873780/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/album/saturation-ep-blueface">Saturation EP (Blueface) by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/album=3511873780/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/album/saturation-ep-blueface">Saturation EP (Blueface) by Urban Dekoy</a></iframe>'
  },
  {
    id: 11,
    name: "Proximity",
    year: 2024,
    tags: {
      context: ["Dancefloor"],
      intensity: ["Soft"],
      standalone: ["Quirky"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/track=3114995292/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/proximity-jake-the-electric-nudes">Proximity (Jake & the Electric Nudes) by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/track=3114995292/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/track/proximity-jake-the-electric-nudes">Proximity (Jake & the Electric Nudes) by Urban Dekoy</a></iframe>'
  },
  {
    id: 12,
    name: "Reposession",
    year: 2024,
    tags: {
      context: ["Dancefloor"],
      intensity: ["Harder"]
    },
    embedCode: '<iframe style="border: 0; width: 100%; height: 120px;" src="https://bandcamp.com/EmbeddedPlayer/album=2981253682/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/artwork=small/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/album/stellas-in-the-swing-ep-jake-t-e-n">Stella\'s in the swing EP (Jake &amp; T.E.N.) by Urban Dekoy</a></iframe>',
    artworkEmbed: '<iframe style="border: 0; width: 350px; height: 350px;" src="https://bandcamp.com/EmbeddedPlayer/album=2981253682/size=large/bgcol=ffffff/linkcol=0687f5/minimal=true/transparent=true/" seamless><a href="https://urbandekoy.bandcamp.com/album/stellas-in-the-swing-ep-jake-t-e-n">Stella\'s in the swing EP (Jake &amp; T.E.N.) by Urban Dekoy</a></iframe>'
  },
  {
    id: 13,
    name: "Blueface DJ mix",
    year: 2024,
    tags: {
      context: ["Mix"],
      intensity: ["Medium"]
    },
    embedCode: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A74164489&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
    artworkEmbed: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A74164489&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>'
  },
  {
    id: 14,
    name: "Slasher",
    year: 2025,
    tags: {
      context: ["Dancefloor"],
      intensity: ["Medium"],
      standalone: ["Quirky"]
    },
    audioFile: "/music/slasher.mp3"
  }
];

// Tag categories and options (for desktop only)
const tagCategories = {
  context: {
    name: "Context",
    options: ["Listening", "Dancefloor", "Mix"],
    mutuallyExclusive: true,
    color: "#3b82f6"
  },
  intensity: {
    name: "Intensity",
    options: ["Soft", "Medium", "Harder"],
    mutuallyExclusive: true,
    color: "#ef4444"
  },
  standalone: {
    name: "Tags",
    options: ["Quirky", "Tech", "303", "Melodic", "Ambient"],
    mutuallyExclusive: false,
    color: "#a855f7"
  }
};

// ─── SIMUSIC Support Modal ────────────────────────────────────────────────────
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mpqjrpyr';

function SupportModal({ onClose }) {
  const [form, setForm] = useState({ name: '', email: '', message: '', consent: false });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.consent) return;
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: form.name, email: form.email, message: form.message })
      });
      if (res.ok) {
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '0.65rem 0.75rem',
    backgroundColor: '#1a1a1a',
    border: '1px solid #333',
    borderRadius: '0.4rem',
    color: '#fff',
    fontSize: '0.95rem',
    boxSizing: 'border-box',
    outline: 'none'
  };

  const labelStyle = {
    display: 'block',
    color: '#ccc',
    fontSize: '0.85rem',
    marginBottom: '0.35rem'
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        backgroundColor: 'rgba(0,0,0,0.85)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, padding: '1rem'
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          backgroundColor: '#111',
          border: '1px solid #f97316',
          borderRadius: '0.75rem',
          padding: '2rem',
          maxWidth: '480px',
          width: '100%',
          position: 'relative'
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: '1rem', right: '1rem',
            background: 'none', border: 'none', color: '#999',
            fontSize: '1.4rem', cursor: 'pointer', lineHeight: 1
          }}
        >
          ×
        </button>

        <h2 style={{ color: '#f97316', margin: '0 0 0.25rem', fontSize: '1.4rem' }}>SIMUSIC Support</h2>
        <p style={{ color: '#888', fontSize: '0.85rem', margin: '0 0 1.5rem' }}>
          Fill in the form below and we'll get back to you.
        </p>

        {status === 'success' ? (
          <div style={{ textAlign: 'center', padding: '1rem 0' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✓</div>
            <p style={{ color: '#f97316', fontWeight: 'bold', fontSize: '1.1rem' }}>Request received!</p>
            <p style={{ color: '#aaa', fontSize: '0.9rem' }}>We'll be in touch at {form.email}.</p>
            <button
              onClick={onClose}
              style={{
                marginTop: '1.25rem',
                backgroundColor: '#f97316', color: '#000',
                border: 'none', borderRadius: '0.4rem',
                padding: '0.6rem 1.5rem', fontWeight: 'bold',
                cursor: 'pointer', fontSize: '0.95rem'
              }}
            >
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <label style={labelStyle}>Name</label>
              <input
                name="name" type="text" required
                value={form.name} onChange={handleChange}
                placeholder="Your name"
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Email</label>
              <input
                name="email" type="email" required
                value={form.email} onChange={handleChange}
                placeholder="your@email.com"
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>How can we help?</label>
              <textarea
                name="message" required
                value={form.message} onChange={handleChange}
                placeholder="Describe your issue or question..."
                rows={4}
                style={{ ...inputStyle, resize: 'vertical' }}
              />
            </div>
            <label style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', cursor: 'pointer' }}>
              <input
                name="consent" type="checkbox"
                checked={form.consent} onChange={handleChange}
                required
                style={{ marginTop: '0.2rem', accentColor: '#f97316', flexShrink: 0 }}
              />
              <span style={{ color: '#aaa', fontSize: '0.8rem', lineHeight: '1.4' }}>
                I agree to my contact details being processed for the purpose of providing support for SIMUSIC.
                Your details will not be used for any other purpose.
              </span>
            </label>

            {status === 'error' && (
              <p style={{ color: '#ef4444', fontSize: '0.85rem', margin: 0 }}>
                Something went wrong. Please try again or email us directly.
              </p>
            )}

            <button
              type="submit"
              disabled={!form.consent || status === 'submitting'}
              style={{
                backgroundColor: form.consent ? '#f97316' : '#555',
                color: form.consent ? '#000' : '#888',
                border: 'none', borderRadius: '0.4rem',
                padding: '0.75rem', fontWeight: 'bold',
                cursor: form.consent ? 'pointer' : 'not-allowed',
                fontSize: '1rem', transition: 'all 0.2s'
              }}
            >
              {status === 'submitting' ? 'Sending...' : 'Send Support Request'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

// ─── SIMUSIC Page ─────────────────────────────────────────────────────────────
function SIMUSICPage({ onBack }) {
  const [showModal, setShowModal] = useState(false);

  const screenshots = [
    { src: '/IMG0015.jpg', alt: 'SIMUSIC home screen showing playlists' },
    { src: '/IMG0016.jpg', alt: 'SIMUSIC sample playlist screen' },
    { src: '/IMG0017.jpg', alt: 'SIMUSIC now playing with animated visualizer' },
    { src: '/IMG0018.jpg', alt: 'SIMUSIC import music menu' }
  ];

  const features = [
    'Import music files from your phone\'s memory at: Files / SIMUSIC',
    'Create custom playlists (like your own CD collection)',
    'Simple, clean interface with animated visualizer',
    'No data collection or tracking',
    'No algorithm trying to "improve" your taste',
    'Complete offline playback'
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#000', color: '#fff' }}>
      {showModal && <SupportModal onClose={() => setShowModal(false)} />}

      {/* Header */}
      <header style={{ backgroundColor: '#0a0a0a', borderBottom: '1px solid #222', padding: '1rem 1.5rem' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <button
            onClick={onBack}
            style={{
              background: 'none', border: '1px solid #444', color: '#aaa',
              padding: '0.4rem 0.9rem', borderRadius: '0.4rem',
              cursor: 'pointer', fontSize: '0.85rem'
            }}
          >
            ← Urban Dekoy
          </button>
          <span style={{ color: '#f97316', fontWeight: 'bold', fontSize: '1.2rem', letterSpacing: '0.1em' }}>
            SIMUSIC
          </span>
        </div>
      </header>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

        {/* Coming soon badge */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <span style={{
            display: 'inline-block',
            backgroundColor: '#1a1a00',
            border: '1px solid #f97316',
            color: '#f97316',
            padding: '0.4rem 1.25rem',
            borderRadius: '2rem',
            fontSize: '0.85rem',
            fontWeight: '600',
            letterSpacing: '0.08em',
            marginBottom: '1.25rem'
          }}>
            COMING SOON — iOS APP STORE
          </span>
          <h1 style={{
            fontSize: 'clamp(2.5rem, 6vw, 4rem)',
            fontWeight: 'bold',
            margin: '0 0 0.5rem',
            letterSpacing: '0.15em',
            color: '#fff'
          }}>
            SIMUSIC
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', margin: 0 }}>
            Your music. Offline. Nothing else.
          </p>
        </div>

        {/* Screenshots */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: '1rem',
          marginBottom: '3rem'
        }}>
          {screenshots.map((s, i) => (
            <div
              key={i}
              style={{
                borderRadius: '1rem',
                overflow: 'hidden',
                border: '1px solid #222',
                boxShadow: '0 4px 24px rgba(249,115,22,0.1)'
              }}
            >
              <img
                src={s.src}
                alt={s.alt}
                style={{ width: '100%', display: 'block' }}
              />
            </div>
          ))}
        </div>

        {/* Promo text */}
        <div style={{
          backgroundColor: '#0d0d0d',
          border: '1px solid #222',
          borderRadius: '0.75rem',
          padding: '2rem',
          marginBottom: '2.5rem'
        }}>
          <p style={{ color: '#ddd', lineHeight: '1.7', fontSize: '1rem', margin: '0 0 1.25rem' }}>
            Remember when music was personal? SIMUSIC brings back the pure joy of curating your own
            music collection — no algorithms, no recommendations, no ads.
          </p>
          <p style={{ color: '#ddd', lineHeight: '1.7', fontSize: '1rem', margin: '0 0 1.5rem' }}>
            Import your MP3 files and organize them exactly how you want. Create playlists like making
            mix tapes. Your music, your way.
          </p>

          <h3 style={{ color: '#f97316', fontSize: '1rem', fontWeight: '600', margin: '0 0 0.75rem', letterSpacing: '0.05em' }}>
            FEATURES
          </h3>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {features.map((f, i) => (
              <li key={i} style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', color: '#ccc', fontSize: '0.95rem', lineHeight: '1.5' }}>
                <span style={{ color: '#f97316', flexShrink: 0 }}>▸</span>
                {f}
              </li>
            ))}
          </ul>

          <p style={{ color: '#ddd', lineHeight: '1.7', fontSize: '1rem', margin: '1.5rem 0 0.75rem' }}>
            For people who miss owning their music. No cloud, no streaming, no suggestions — just
            the songs you chose, organized how you like them.
          </p>
          <p style={{ color: '#888', lineHeight: '1.7', fontSize: '0.95rem', fontStyle: 'italic', margin: 0 }}>
            Like having a personal stereo that actually belongs to you.
          </p>
        </div>

        {/* Support button */}
        <div style={{ textAlign: 'center' }}>
          <p style={{ color: '#888', fontSize: '0.9rem', marginBottom: '1rem' }}>
            Questions or need support once you're using the app?
          </p>
          <button
            onClick={() => setShowModal(true)}
            style={{
              backgroundColor: '#f97316',
              color: '#000',
              border: 'none',
              borderRadius: '0.5rem',
              padding: '0.85rem 2rem',
              fontWeight: 'bold',
              fontSize: '1rem',
              cursor: 'pointer',
              letterSpacing: '0.05em'
            }}
          >
            Request Support
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Main App ─────────────────────────────────────────────────────────────────
function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedTags, setSelectedTags] = useState({
    context: [],
    intensity: [],
    standalone: []
  });
  const [showFilters, setShowFilters] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Safe mobile detection with SSR support
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const filteredCatalog = useMemo(() => {
    if (isMobile) return musicCatalog;

    return musicCatalog.filter(track => {
      return Object.keys(selectedTags).every(category => {
        const selectedInCategory = selectedTags[category];
        if (selectedInCategory.length === 0) return true;

        const trackTags = track.tags[category] || [];
        return selectedInCategory.some(tag => trackTags.includes(tag));
      });
    });
  }, [selectedTags, isMobile]);

  const toggleTag = (category, tag) => {
    setSelectedTags(prev => {
      const categoryConfig = tagCategories[category];
      if (categoryConfig.mutuallyExclusive) {
        return {
          ...prev,
          [category]: prev[category].includes(tag) ? [] : [tag]
        };
      } else {
        return {
          ...prev,
          [category]: prev[category].includes(tag)
            ? prev[category].filter(t => t !== tag)
            : [...prev[category], tag]
        };
      }
    });
  };

  const clearFilters = () => {
    setSelectedTags({
      context: [],
      intensity: [],
      standalone: []
    });
  };

  const getAllTagsForTrack = (track) => {
    const allTags = [];
    Object.keys(track.tags).forEach(category => {
      track.tags[category].forEach(tag => {
        allTags.push({ tag, category });
      });
    });
    return allTags;
  };

  const totalSelectedTags = Object.values(selectedTags).flat().length;

  if (currentPage === 'simusic') {
    return <SIMUSICPage onBack={() => setCurrentPage('home')} />;
  }

  // Mobile version
  if (isMobile) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#000',
        color: '#fff',
        overflowX: 'hidden',
        width: '100%'
      }}>
        <header style={{
          background: `
            url('/urban-texture.png') center/cover no-repeat,
            url('/urban-texture.jpg') center/cover no-repeat,
            url('/urban-texture.jpeg') center/cover no-repeat,
            linear-gradient(135deg, #333333, #555555)
          `,
          padding: '3rem 1.5rem',
          position: 'relative'
        }}>
          <div style={{ 
            textAlign: 'center',
            position: 'relative',
            zIndex: 2
          }}>
            <h1 style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              margin: 0,
              color: '#fff',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
              letterSpacing: '0.1em',
              lineHeight: '1.1'
            }}>
              <div>URBAN</div>
              <div>DEKOY</div>
            </h1>
            <button
              onClick={() => setCurrentPage('simusic')}
              style={{
                marginTop: '1rem',
                background: 'none',
                border: 'none',
                color: '#f97316',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                letterSpacing: '0.1em',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
                padding: 0
              }}
            >
              SIMUSIC →
            </button>
          </div>
        </header>

        <div style={{ 
          padding: '1rem',
          overflowX: 'hidden'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
            maxWidth: '100vw'
          }}>
            {musicCatalog.map(track => (
              <div
                key={track.id}
                style={{
                  backgroundColor: '#1f2937',
                  borderRadius: '0.5rem',
                  padding: '0.5rem',
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                  maxWidth: 'calc(100vw - 2rem)',
                  boxSizing: 'border-box'
                }}
              >
                {track.audioFile ? (
                  // Local MP3 audio player for mobile - White box with album art
                  <div style={{
                    width: '100%',
                    maxWidth: '350px',
                    backgroundColor: '#ffffff',
                    borderRadius: '0.25rem',
                    padding: '0.75rem',
                    margin: '0.5rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}>
                    {/* Album Art - Square at top */}
                    <img
                      src={track.audioFile.replace('.mp3', '.jpg')}
                      onError={(e) => {
                        // Try .png if .jpg fails
                        if (e.target.src.endsWith('.jpg')) {
                          e.target.src = track.audioFile.replace('.mp3', '.png');
                        } else {
                          // Use default image if both fail
                          e.target.src = '/music/UrbanDekoy_1500x1500_grey.jpg';
                        }
                      }}
                      alt={track.name}
                      style={{
                        width: '100%',
                        maxWidth: '320px',
                        aspectRatio: '1',
                        objectFit: 'cover'
                      }}
                    />

                    {/* Track Title */}
                    <div style={{
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      color: '#000',
                      textAlign: 'center',
                      width: '100%'
                    }}>
                      Bonus track: {track.name}
                    </div>

                    {/* Audio Player */}
                    <audio
                      controls
                      style={{
                        width: '100%',
                        maxWidth: '320px'
                      }}
                    >
                      <source src={track.audioFile} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>

                    {/* Download Button */}
                    <a
                      href={track.audioFile}
                      download
                      style={{
                        display: 'inline-block',
                        padding: '0.5rem 1rem',
                        backgroundColor: '#3b82f6',
                        color: '#fff',
                        textDecoration: 'none',
                        borderRadius: '0.25rem',
                        textAlign: 'center',
                        fontSize: '0.875rem',
                        fontWeight: '500'
                      }}
                    >
                      ⬇ Download MP3
                    </a>
                  </div>
                ) : (
                  // Bandcamp/SoundCloud embed (existing tracks)
                  <div
                    style={{
                      width: '100%',
                      maxWidth: '350px',
                      overflow: 'hidden'
                    }}
                    dangerouslySetInnerHTML={{ __html: track.artworkEmbed }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Desktop version
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#000', color: '#fff' }}>
      <header style={{
        background: `
          url('/urban-texture.png') center/cover no-repeat,
          url('/urban-texture.jpg') center/cover no-repeat,
          url('/urban-texture.jpeg') center/cover no-repeat,
          linear-gradient(135deg, #333333, #555555)
        `,
        padding: '3rem 1.5rem', // or '2rem' for desktop  
        position: 'relative'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto',
          position: 'relative',
          zIndex: 2
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            marginBottom: '1rem'
          }}>
            <h1 style={{ 
              fontSize: '4rem', 
              fontWeight: 'bold', 
              margin: 0,
              color: '#fff',
              textShadow: '3px 3px 6px rgba(0, 0, 0, 0.8)',
              letterSpacing: '0.15em',
              display: 'flex',
              alignItems: 'baseline',
              gap: '1rem',
              flexWrap: 'nowrap'
            }}>
              URBAN DEKOY
              <span style={{
                fontSize: '0.8rem',
                fontWeight: 'normal',
                color: 'rgba(255, 255, 255, 0.8)',
                letterSpacing: 'normal'
              }}>
                {VERSION}
              </span>
            </h1>

            <button
              onClick={() => setShowFilters(!showFilters)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                backgroundColor: '#374151',
                border: 'none',
                color: '#fff',
                padding: '0.75rem 1rem',
                borderRadius: '0.5rem',
                cursor: 'pointer'
              }}
            >
              🔍 Filters {totalSelectedTags > 0 && `(${totalSelectedTags})`}
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
            <a
              href="/Influences_Map.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                color: '#9ca3af',
                textDecoration: 'underline',
                fontSize: '1.1rem',
                cursor: 'pointer'
              }}
            >
              Interactive Techno Influences Map
            </a>
            <button
              onClick={() => setCurrentPage('simusic')}
              style={{
                background: 'none',
                border: 'none',
                color: '#f97316',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                letterSpacing: '0.1em',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
                padding: 0
              }}
            >
              SIMUSIC →
            </button>
          </div>
        </div>
      </header>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '1.5rem' }}>
        {showFilters && (
          <div style={{
            backgroundColor: '#1f2937',
            borderRadius: '0.5rem',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              {Object.entries(tagCategories).map(([categoryKey, categoryConfig]) => (
                <div key={categoryKey}>
                  <h3 style={{
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    marginBottom: '0.5rem',
                    color: categoryConfig.color,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    {categoryConfig.name}
                    {categoryConfig.mutuallyExclusive && (
                      <span style={{ fontSize: '0.7rem', color: '#9ca3af' }}>(pick one)</span>
                    )}
                  </h3>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                    {categoryConfig.options.map(tag => (
                      <button
                        key={tag}
                        onClick={() => toggleTag(categoryKey, tag)}
                        style={{
                          padding: '0.4rem 0.6rem',
                          borderRadius: '0.8rem',
                          fontSize: '0.75rem',
                          border: 'none',
                          cursor: 'pointer',
                          backgroundColor: selectedTags[categoryKey].includes(tag) ? categoryConfig.color : '#374151',
                          color: selectedTags[categoryKey].includes(tag) ? '#fff' : '#d1d5db',
                          transition: 'all 0.2s'
                        }}
                      >
                        {tag}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {totalSelectedTags > 0 && (
              <button
                onClick={clearFilters}
                style={{
                  marginTop: '1rem',
                  color: '#9ca3af',
                  backgroundColor: 'transparent',
                  border: 'none',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontSize: '0.8rem'
                }}
              >
                Clear all filters
              </button>
            )}
          </div>
        )}

        <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
          <p style={{ color: '#9ca3af' }}>
            Showing {filteredCatalog.length} of {musicCatalog.length} releases
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {filteredCatalog.map(track => (
            <div
              key={track.id}
              style={{
                backgroundColor: '#1f2937',
                borderRadius: '0.5rem',
                overflow: 'hidden',
                transition: 'background-color 0.2s',
                display: 'flex',
                alignItems: 'center',
                minHeight: '140px'
              }}
            >
              {track.audioFile ? (
                // Local MP3 audio player for desktop - White box with album art
                <div
                  style={{
                    width: '400px',
                    flexShrink: 0,
                    backgroundColor: '#ffffff',
                    borderRadius: '0.25rem',
                    padding: '0.75rem',
                    margin: '1rem',
                    display: 'flex',
                    gap: '0.75rem',
                    alignItems: 'flex-start'
                  }}
                >
                  {/* Album Art - Left side */}
                  <img
                    src={track.audioFile.replace('.mp3', '.jpg')}
                    onError={(e) => {
                      // Try .png if .jpg fails
                      if (e.target.src.endsWith('.jpg')) {
                        e.target.src = track.audioFile.replace('.mp3', '.png');
                      } else {
                        // Use default image if both fail
                        e.target.src = '/music/UrbanDekoy_1500x1500_grey.jpg';
                      }
                    }}
                    alt={track.name}
                    style={{
                      width: '120px',
                      height: '120px',
                      objectFit: 'cover',
                      flexShrink: 0
                    }}
                  />

                  {/* Content - Right side */}
                  <div style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    minWidth: 0
                  }}>
                    <div style={{
                      fontSize: '0.9rem',
                      fontWeight: 'bold',
                      color: '#000',
                      lineHeight: '1.2'
                    }}>
                      Bonus track: {track.name}
                    </div>
                    <audio
                      controls
                      style={{
                        width: '100%',
                        height: '32px'
                      }}
                    >
                      <source src={track.audioFile} type="audio/mpeg" />
                      Your browser does not support the audio element.
                    </audio>
                    <a
                      href={track.audioFile}
                      download
                      style={{
                        display: 'inline-block',
                        padding: '0.4rem 0.8rem',
                        backgroundColor: '#3b82f6',
                        color: '#fff',
                        textDecoration: 'none',
                        borderRadius: '0.25rem',
                        textAlign: 'center',
                        fontSize: '0.75rem',
                        fontWeight: '500',
                        alignSelf: 'flex-start'
                      }}
                    >
                      ⬇ Download MP3
                    </a>
                  </div>
                </div>
              ) : (
                // Bandcamp/SoundCloud embed (existing tracks)
                <div
                  style={{
                    width: '400px',
                    flexShrink: 0,
                    padding: '1rem'
                  }}
                  dangerouslySetInnerHTML={{ __html: track.embedCode }}
                />
              )}

              <div style={{
                flex: 1,
                padding: '1rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: '0.75rem'
              }}>
                <div style={{
                  fontSize: '0.875rem',
                  color: '#9ca3af',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  {track.year}
                </div>

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  {getAllTagsForTrack(track).map(({ tag, category }, index) => (
                    <span
                      key={`${category}-${tag}-${index}`}
                      style={{
                        padding: '0.4rem 0.8rem',
                        backgroundColor: selectedTags[category].includes(tag) ? tagCategories[category].color : '#374151',
                        borderRadius: '1rem',
                        fontSize: '0.8rem',
                        color: selectedTags[category].includes(tag) ? '#fff' : '#d1d5db',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        border: `1px solid ${tagCategories[category].color}40`
                      }}
                      onClick={() => toggleTag(category, tag)}
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredCatalog.length === 0 && (
          <div style={{ textAlign: 'center', padding: '3rem 0' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎵</div>
            <p style={{ color: '#9ca3af', fontSize: '1.125rem' }}>No tracks match your current filters</p>
            <button
              onClick={clearFilters}
              style={{
                marginTop: '1rem',
                color: '#a855f7',
                backgroundColor: 'transparent',
                border: 'none',
                textDecoration: 'underline',
                cursor: 'pointer'
              }}
            >
              Clear filters to see all tracks
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
